import React from 'react'
import getConfig from 'next/config'

import { useSidebarLogoStyles } from './styles'

const { VERSION } = getConfig().publicRuntimeConfig

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles()

  return (
    <div className={classes.logoWrapper}>
      <img alt="IPEX" src={'/images/content/logo.png'} title={`Verze: ${VERSION}`} />
    </div>
  )
}

export { SidebarLogo }
